import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'pt-BR', flag: '🇧🇷', label: 'PT' },
    { code: 'es', flag: '🇪🇸', label: 'ES' },
    { code: 'en', flag: '🇺🇸', label: 'EN' },
  ];

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex w-fit gap-2 items-center bg-console-bg/20 backdrop-blur-sm p-1.5 rounded-full border border-white/10 shadow-lg">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 ${
            i18n.language === lang.code 
              ? 'bg-[#98c136] text-black shadow-[0_0_15px_rgba(152,193,54,0.4)]' 
              : 'bg-white/5 text-console-text hover:bg-white/10'
          }`}
          title={lang.label}
        >
          <span className="text-lg leading-none">{lang.flag}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
